import type React from 'react';

import { Box, FormField, Label, Textarea } from '@zillow/constellation-10';

import type { Section } from '../../../../models/index';
import { LANDSCAPING } from '../../../../constants';
import Landscaping_v1 from './Landscaping_v1';
import OptionSelector from '../Utilities/OptionSelector';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function Landscaping_v2({ section, setSectionValues }: Props): JSX.Element {
  function setOption1(): void {
    setSectionValues({
      [LANDSCAPING.FIELD_NAME.TENANT_RESPONSIBILITY]: true,
      [LANDSCAPING.FIELD_NAME.LANDLORD_RESPONSIBILITY]: false,
      [LANDSCAPING.FIELD_NAME.IS_ENABLED]: true,
      [LANDSCAPING.FIELD_NAME.SERVICES]: '',
    });
  }

  function setOption2(): void {
    setSectionValues({
      [LANDSCAPING.FIELD_NAME.TENANT_RESPONSIBILITY]: false,
      [LANDSCAPING.FIELD_NAME.LANDLORD_RESPONSIBILITY]: true,
      [LANDSCAPING.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  function setServices(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    setSectionValues({
      [LANDSCAPING.FIELD_NAME.SERVICES]: event.currentTarget.value,
    });
  }

  function renderOption2Details(): React.ReactNode {
    return (
      <FormField
        required
        label={<Label id="services-provided">What services will be provided?</Label>}
        control={
          <Textarea
            aria-labelledby="services-provided"
            css={{ resize: 'vertical' }}
            value={section.getFieldValue(LANDSCAPING.FIELD_NAME.SERVICES)}
            onChange={setServices}
          />
        }
      />
    );
  }

  function renderOptionSelector(): React.ReactNode {
    const landscaping_isEnabled = section.getFieldValue(LANDSCAPING.FIELD_NAME.IS_ENABLED);
    const option1Selected = section.getFieldValue(LANDSCAPING.FIELD_NAME.TENANT_RESPONSIBILITY);
    const option2Selected = section.getFieldValue(LANDSCAPING.FIELD_NAME.LANDLORD_RESPONSIBILITY);
    const option1Content = 'Responsible for reasonable upkeep including lawn mowing and leaf raking.';
    const option2Content = 'Responsible for reasonable upkeep including lawn mowing and leaf raking.';

    return (
      <>
        <OptionSelector
          disabled={!landscaping_isEnabled}
          optionsText="Who will be responsible for landscaping?"
          option1Selected={option1Selected}
          option1Content={option1Content}
          onOption1Click={setOption1}
          option2Selected={option2Selected}
          option2Content={option2Content}
          onOption2Click={setOption2}
        />
        {option2Selected && <Box css={{ marginTop: 'layout.tight' }}>{renderOption2Details()}</Box>}
      </>
    );
  }

  return <Landscaping_v1 section={section} setSectionValues={setSectionValues} customOption={renderOptionSelector()} />;
}

Landscaping_v2.description = 'Only asks for services provided';
